import AuthenticatedLayout from '@/layouts/AuthenticatedLayout'
import AssessmentPage from '@/pages/Assessment'
import Dashboard from '@/pages/Dashboard'
import ResultsPage from '@/pages/Results'
import SettingsPage from '@/pages/Settings'
import LearningPathPage from '@/pages/LearningPath'
import VideoPlayerPage from '@/pages/LearningPath/VideoPlayer'
import OrganizationAnalytics from '@/pages/Organization/Analytics'
import CouplesInvitation from '@/pages/Organization/CouplesInvitation'
import CoupleManagement from '@/pages/Organization/CoupleManagement'
import CoupleDetails from '@/pages/Organization/CoupleManagement/CoupleDetails'
import InternalUserManagement from '@/pages/Organization/InternalUserManagement'
import LoginPage from '@/pages/Login'
import CreatePasswordPage from '@/pages/CreatePassword'
import SetPasswordPage from '@/pages/SetPassword'
import VerifyAccountPage from '@/pages/VerifyAccount'
import { createBrowserRouter } from 'react-router'
import { ProtectedRoute } from './ProtectedRoute'
import AdminLayout from '@/layouts/AdminLayout'
import AdminDashboard from '@/pages/Admin/Dashboard'
import AdminUsersPage from '@/pages/Admin/Users'
import AdminOrganizationsPage from '@/pages/Admin/Organizations'
import AdminAnalyticsPage from '@/pages/Admin/Analytics'
import AdminLearningPage from '@/pages/Admin/Learning'
import AdminLearningPathManagement from '@/pages/Admin/LearningPathManagement'
import AdminSystemPage from '@/pages/Admin/System'
import AdminReportsPage from '@/pages/Admin/Reports'
import AdminWaitlistPage from '@/pages/Admin/Waitlist'
import AdminContentPage from '@/pages/Admin/Content'
import AdminCouplesPage from '@/pages/Admin/Couples'
import AdminQuestionsPage from '@/pages/Admin/Questions'
import AdminCoupleDetail from '@/pages/Admin/CoupleDetail'
import AdminOrganizationDetail from '@/pages/Admin/OrganizationDetail'
import AdminAssessmentDetail from '@/pages/Admin/AssessmentDetail'
import AdminUserDetail from '@/pages/Admin/UserDetail'
import AcceptInvitationPage from '@/pages/Couples/AcceptInvitation'
import LandingPage from '@/pages/Landing'

// Placeholder components for missing pages
function ErrorPage() {
  return (
    <div className='flex items-center justify-center min-h-screen'>
      <div className='text-center'>
        <h1 className='text-4xl font-bold text-gray-900 mb-4'>404</h1>
        <p className='text-gray-600'>Page not found</p>
      </div>
    </div>
  )
}

export const router = createBrowserRouter([
  {
    path: '/',
    errorElement: <ErrorPage />,
    children: [
      {
        index: true,
        element: <LandingPage />,
      },
      {
        path: 'login',
        element: <LoginPage />,
      },
      {
        path: 'create-password',
        element: <CreatePasswordPage />,
      },
      {
        path: 'set-password',
        element: <SetPasswordPage />,
      },
      {
        path: 'accept-invitation/:coupleId',
        element: <AcceptInvitationPage />,
      },
      {
        path: 'verify-account',
        element: <VerifyAccountPage />,
      },
      {
        path: 'about',
        element: (
          <div className='p-8'>
            <h1 className='text-3xl font-bold'>About Page</h1>
          </div>
        ),
      },
    ],
  },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: 'dashboard',
        element: <Dashboard />,
      },
      {
        path: 'assessment',
        element: <AssessmentPage />,
      },
      {
        path: 'results',
        element: <ResultsPage />,
      },
      {
        path: 'learning-path',
        element: <LearningPathPage />,
      },
      {
        path: 'learning-path/video/:videoId',
        element: <VideoPlayerPage />,
      },
      {
        path: 'settings',
        element: <SettingsPage />,
      },
    ],
  },
  {
    path: '/organization',
    element: (
      <ProtectedRoute>
        <AuthenticatedLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        path: 'analytics',
        element: <OrganizationAnalytics />,
      },
      {
        path: 'invitation',
        element: <CouplesInvitation />,
      },
      {
        path: 'couples',
        element: <CoupleManagement />,
      },
      {
        path: 'couples/:id',
        element: <CoupleDetails />,
      },
      {
        path: 'users',
        element: <InternalUserManagement />,
      },
      {
        path: 'settings',
        element: <SettingsPage />,
      },
    ],
  },
  {
    path: '/admin',
    element: (
      <ProtectedRoute>
        <AdminLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: 'dashboard', element: <AdminDashboard /> },
      { path: 'users', element: <AdminUsersPage /> },
      { path: 'users/:userId', element: <AdminUserDetail /> },
      { path: 'couples', element: <AdminCouplesPage /> },
      { path: 'couples/:coupleId', element: <AdminCoupleDetail /> },
      { path: 'assessments/:assessmentId', element: <AdminAssessmentDetail /> },
      { path: 'organizations', element: <AdminOrganizationsPage /> },
      { path: 'organizations/:organizationId', element: <AdminOrganizationDetail /> },
      { path: 'analytics', element: <AdminAnalyticsPage /> },
      { path: 'learning', element: <AdminLearningPage /> },
      { path: 'learning-path', element: <AdminLearningPathManagement /> },
      { path: 'questions', element: <AdminQuestionsPage /> },
      { path: 'system', element: <AdminSystemPage /> },
      { path: 'reports', element: <AdminReportsPage /> },
      { path: 'waitlist', element: <AdminWaitlistPage /> },
      { path: 'content', element: <AdminContentPage /> },
      { path: 'settings', element: <SettingsPage /> },
    ],
  },
])

export default router
